import { render, staticRenderFns } from "./SidebarAccount.vue?vue&type=template&id=3f1fb2fc&"
import script from "./SidebarAccount.vue?vue&type=script&lang=js&"
export * from "./SidebarAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports